import Vue from 'vue'
import Vuex from 'vuex'
import auth from './auth'
import admin from './admin'
import termReports from './termReports'
import markBook from './markBook'
import axios from 'axios'
import weeklyTests from './weeklyTests'

axios.defaults.withCredentials = true
axios.defaults.baseURL = process.env.VUE_APP_API_URI;
axios.defaults.headers.common['Access-Control-Allow-Origin'] = '*';
axios.defaults.headers.common['Authorization'] = `Bearer ${sessionStorage.getItem('access_token')}`;

Vue.use(Vuex)

export default new Vuex.Store({
    modules: {
        auth, 
        termReports,
        markBook,
        admin,
        weeklyTests,
    },
    actions: {
        logout({commit}){
            commit('termReports/resetState', null, { root: true });
            commit('markBook/resetState', null, { root: true });
        }
    }
})